import SnAvailabilityListTable from "./snAvailabilityListTable.container";

export default SnAvailabilityListTable;
